Properties.store.state = {
    favorites: window.localStorage.getItem('favorites') !== null ? window.localStorage.getItem('favorites').split(',') : [],
    sortOption: '',
    viewMode: '',
    showBrochureModal: false,
    imagesLoading: false,
    showViewingModal: false,
    showOfferModal: false,
    showFilters: false
};